import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getMessage } from '@gef-ui/localization/messages';

import { currency, percentage } from 'utils';

export const LegendAndData = ({ contactsSummary }) => {
	const badgeSx = {
		'& .MuiBadge-dot': {
			marginTop: 1.25,
			marginRight: 2,
		},
	};

	return (
		<Stack spacing={2}>
			<Stack>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'space-between',
					}}
				>
					<Stack direction="row">
						<Badge sx={{ ...badgeSx }} variant="dot" color="error" />
						<Typography variant="body1">{getMessage('dashboard:campaigns.inProgress')}</Typography>
					</Stack>
					<Typography
						variant="body1"
						sx={{
							fontWeight: 'bold',
						}}
					>
						{contactsSummary?.notDone}
					</Typography>
				</Stack>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'space-between',
					}}
				>
					<Stack direction="row">
						<Badge sx={{ ...badgeSx }} variant="dot" color="warning" />
						<Typography variant="body1">{getMessage('dashboard:campaigns.draft')}</Typography>
					</Stack>
					<Typography
						variant="body1"
						sx={{
							fontWeight: 'bold',
						}}
					>
						{contactsSummary?.progress}
					</Typography>
				</Stack>
			</Stack>
			<Stack>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'space-between',
					}}
				>
					<Typography variant="body1">{getMessage('dashboard:campaigns.fulfillment')}</Typography>
					<Typography
						variant="body1"
						sx={{
							fontWeight: 'bold',
						}}
					>
						{percentage(contactsSummary?.fullfillment)}
					</Typography>
				</Stack>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'space-between',
					}}
				>
					<Typography variant="body1">{getMessage('dashboard:campaigns.production')}</Typography>
					<Typography
						variant="body1"
						sx={{
							fontWeight: 'bold',
						}}
					>
						{currency(contactsSummary?.production)}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};

LegendAndData.propTypes = {
	contactsSummary: PropTypes.shape({
		fullfillment: PropTypes.number,
		notDone: PropTypes.number,
		production: PropTypes.number,
		progress: PropTypes.number,
	}),
};

export default LegendAndData;
